// Source unique de vérité des plages de fréquence.
// Évite la désync : App et QuizGame doivent partager EXACTEMENT le même tableau
// (indexOf/promotion/rétrogradation). Les valeurs représentent le nombre maximal
export const FREQUENCY_VALUES = [500, 1000, 2000, 4000, 6000];
export const FREQUENCY_NAMES  = ['500 mots', '1 000 mots', '2 000 mots', '4 000 mots', '6 000 mots'];

// Rang « connu » → niveau CECR (estimation de couverture de fréquence, cadrée
// honnêtement côté UI comme indicative). Vivait dans LevelTest.jsx ; remonté ici
// parce que le filtre de fréquence s'en sert aussi. Un barème dupliqué finit
// toujours par diverger, et les deux écrans annonceraient alors deux niveaux
// différents pour le même utilisateur.
export const cefrOf = (words) => {
  if (words < 500) return 'A1';
  if (words < 1200) return 'A2';
  if (words < 2500) return 'B1';
  if (words < 4000) return 'B2';
  return 'C1';
};

// Niveau d'une BANDE de fréquence. La bande « 1 000 mots » couvre les rangs 1 à
// 1 000 : son niveau est celui de son dernier mot. Les seuils de `cefrOf` étant
// exclusifs (< 500 → A1), d'où le -1 — sans lui la bande 500 s'afficherait « A2 ».
//   500 → A1 · 1 000 → A2 · 2 000 → B1 · 4 000 → B2 · 6 000 → C1
export const cefrOfBand = (value) => cefrOf(value - 1);
